import request from './request';

export function fetchDashboardData(financialYear) {
  const url = financialYear ? `dashboard?financial_year=${financialYear}` : 'dashboard';

  return request(url, {
    method: 'GET'
  });
}
